export default "__VITE_ASSET__CJ1OPDzD__"